/**
 * @generated SignedSource<<b43ce596de6144f3130311b6227fb546>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EZoraClaimContractEnv = "PRODUCTION" | "STAGING" | "%future added value";
export type RewardsBreakdownQuery$variables = {
  walletAddresses: ReadonlyArray<string>;
  zoraClaimContractEnv: EZoraClaimContractEnv;
};
export type RewardsBreakdownQuery$data = {
  readonly zoraTokenAllocation: {
    readonly tokensEarnedBonusTokensEarned: {
      readonly totalTokens: number;
    };
    readonly tokensEarnedCreatorReferrals: {
      readonly totalTokens: number;
    };
    readonly tokensEarnedEthSpend: {
      readonly totalTokens: number;
    };
    readonly tokensEarnedMintReferrals: {
      readonly totalTokens: number;
    };
    readonly tokensEarnedMintsOnPosts: {
      readonly totalTokens: number;
    };
    readonly tokensEarnedPosts: {
      readonly totalTokens: number;
    };
    readonly tokensEarnedRewards: {
      readonly totalTokens: number;
    };
  };
};
export type RewardsBreakdownQuery = {
  response: RewardsBreakdownQuery$data;
  variables: RewardsBreakdownQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "walletAddresses"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "zoraClaimContractEnv"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalTokens",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "identifierWalletAddresses",
        "variableName": "walletAddresses"
      },
      {
        "kind": "Variable",
        "name": "zoraClaimContractEnv",
        "variableName": "zoraClaimContractEnv"
      }
    ],
    "concreteType": "GraphQLZoraTokenAllocation",
    "kind": "LinkedField",
    "name": "zoraTokenAllocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLZoraTokenCategoryAllocation",
        "kind": "LinkedField",
        "name": "tokensEarnedMintReferrals",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLZoraTokenCategoryAllocation",
        "kind": "LinkedField",
        "name": "tokensEarnedCreatorReferrals",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLZoraTokenCategoryAllocation",
        "kind": "LinkedField",
        "name": "tokensEarnedPosts",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLZoraTokenCategoryAllocation",
        "kind": "LinkedField",
        "name": "tokensEarnedEthSpend",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLZoraTokenCategoryAllocation",
        "kind": "LinkedField",
        "name": "tokensEarnedRewards",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLZoraTokenCategoryAllocation",
        "kind": "LinkedField",
        "name": "tokensEarnedMintsOnPosts",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLZoraTokenCategoryAllocation",
        "kind": "LinkedField",
        "name": "tokensEarnedBonusTokensEarned",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RewardsBreakdownQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RewardsBreakdownQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f97f703971fed28b9ca924924962d22f",
    "id": null,
    "metadata": {},
    "name": "RewardsBreakdownQuery",
    "operationKind": "query",
    "text": "query RewardsBreakdownQuery(\n  $walletAddresses: [String!]!\n  $zoraClaimContractEnv: EZoraClaimContractEnv!\n) {\n  zoraTokenAllocation(identifierWalletAddresses: $walletAddresses, zoraClaimContractEnv: $zoraClaimContractEnv) {\n    tokensEarnedMintReferrals {\n      totalTokens\n    }\n    tokensEarnedCreatorReferrals {\n      totalTokens\n    }\n    tokensEarnedPosts {\n      totalTokens\n    }\n    tokensEarnedEthSpend {\n      totalTokens\n    }\n    tokensEarnedRewards {\n      totalTokens\n    }\n    tokensEarnedMintsOnPosts {\n      totalTokens\n    }\n    tokensEarnedBonusTokensEarned {\n      totalTokens\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2433a3cdeca8562229d8f8ef37719f14";

export default node;
